import React from 'react'
import Footer from './Essentials/Footer';
import Navbar from './Essentials/Navbar';

import './Css/Result.css';
const Result = () => {
    var searchItem = localStorage.getItem("user-searched-for");
    var view = JSON.parse(localStorage.getItem("search-projects-for"));
    return (
        <>
            <Navbar />
            <center>
                {/* Showing results for */}
                <div className="Heading">
                    {
                        view.length != 0 ?
                            <div style={{
                                padding: '5px',
                                display: 'flex',
                                alignItems: 'center',
                                fontSize: '0.7rem'
                            }}>
                                <h1>Search Results for <span style={{
                                    fontWeight: '400'
                                }}>{searchItem}</span></h1>
                            </div> :
                            <p>No results found for {searchItem}</p>
                    }
                </div>
                <table id="view-projects">
                    {
                        view.map((e, idx) => {
                            return (
                                <>
                                    <hr />
                                    <tr key={idx}>
                                        <td onClick={() => { window.open(e.link, "_self") }}>
                                            <div id="res">
                                                <img style={{ borderRadius: "5px" }} src={(e.image.toString().startsWith('projects/') || e.image.toString().startsWith('http')) ? e.image : 'projects/' + e.image} alt="flag" className="icons-view" />
                                                <p>{e.title.slice(e.title.indexOf('.') + 1)}</p>
                                            </div>
                                        </td>
                                    </tr>

                                </>
                            )
                        })
                    }
                </table>
            </center>

        </>
    )
}
export default Result;